<span class="wrap">
  @if (!_editing) {
    <label [ngStyle]="_style.label" class="editableLabel" (click)="onEdit(true)">{{_value | PipeTruncate:['16']}}</label>
  }
  @if (!_editing && showIcon) {
    <i [ngStyle]="_style.editIcon" (click)="onEdit(true)" class="editableLabel">
      @if (_editable) {
        <mat-icon class="editIcon">edit</mat-icon>
      }
    </i>
  }
  @if (_editing) {
    <div class="wrapEdit">
      <input inputrestriction="basic1" [ngStyle]="_style.input" value="{{_value}}" type="{{_type}}" [(ngModel)]="_value"/>
      <a (click)="onEdit(false)" class="editableLabel">
        <mat-icon>check</mat-icon>
      </a>
    </div>
  }
</span>
